const is_dev_server = !!!window.electron
const log = (...args) => {
    console.log("IpcLogRenderer.js:", ...args)
}
log("is_dev_server=", is_dev_server)

// we need to save the original console object
// since we will probably use console = new IpcLogRenderer()
const console_original = console


// use mock for dev-server that logs to devtools console
const log_dev_server_mock = (level, ...args) => {
    if (level == "info" || level == "log") console_original.info(...args)
    if (level == "error") console_original.error(...args)
    if (level == "warn") console_original.warn(...args)
    // others are not even used ? like "debug", "silly" etc
}


export async function _logRenderer(level = "debug", ...args) {
    log_dev_server_mock(level, ...args)
    if (is_dev_server) return

    // ipc renderer
    let string_args = []
    for (const arg of args) {
        string_args.push(String(arg))
    }
    const ipcRenderer = window.electron.ipcRenderer
    ipcRenderer.send("log", level, ...string_args)
}


/**
 * usage:
 *      // redirect the console to file logger through ipc
        if (!is_web_app) {
            console = new IpcLogRenderer()
 *          logger = new IpcLogRenderer()
        }
 */
export default class IpcLogRenderer {
    // levels: ['error', 'warn', 'info', 'verbose', 'debug', 'silly']
    log(...args) {
        _logRenderer("info", ...args);
    }
    error(...args) {
        _logRenderer("error", ...args);
    }
    warn(...args) {
        _logRenderer("warn", ...args);
    }
    info(...args) {
        _logRenderer("info", ...args);
    }
    verbose(...args) {
        _logRenderer("verbose", ...args);
    }
    debug(...args) {
        _logRenderer("debug", ...args);
    }
    silly(...args) {
        _logRenderer("silly", ...args);
    }
}
